import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpService } from "../../../../../core";
import { MatDialog } from "@angular/material/dialog";
import { ButtonDialogComponent } from "./button-dialog/button-dialog.component";
import { environment } from "../../../../../../environments/environment";


@Component({
    selector: 'eoi-detail',
    templateUrl: './eoi-detail.html',
    styleUrls: ['./eoi-detail.scss']
})
export class EoiDetail implements OnInit {
    SERVER_URL = environment.SERVER_URL;

    @Input() eoiId: number;
    @Output() closeDetail = new EventEmitter();

    eoiDetail: any;
    agentEmail: string = '';
    agentMobile: string = '';

    constructor(
        private route: ActivatedRoute,
        private httpService: HttpService,
        private dialog: MatDialog,
    ) {
    }


    ngOnInit() {
        this.httpService.getEoiDetail(this.eoiId).toPromise().then((res: any) => {
            this.eoiDetail = res.data
            if (res.data.agent) {
                this.agentEmail = res.data.agent.contacts.filter(e => e.contactItem.title.en == 'Email')[0].content
                this.agentMobile = res.data.agent.contacts.filter(e => e.contactItem.title.en == 'Phone Number')[0].content
            }
        })
    }

    back() {
        this.closeDetail.emit()
    }

    approve() {
        this.dialog.open(ButtonDialogComponent, { data: { type: "approve" } }).afterClosed().subscribe(result => {
            if (result.type) {
                this.httpService.approvedEoi(this.eoiId).toPromise().then(res => {
                    this.ngOnInit()
                })
            }
        })
    }

    reject() {
        this.dialog.open(ButtonDialogComponent, { data: { type: "reject" } }).afterClosed().subscribe(result => {
            if (result.type) {
                this.httpService.rejectEoi(this.eoiId, { rejectReason: result.remark }).toPromise().then(res => {
                    this.ngOnInit()
                })
            }
        })
    }

    remove() {
        this.dialog.open(ButtonDialogComponent, { data: { type: "remove" } }).afterClosed().subscribe(result => {
            if (result.type) {
                this.httpService.removeEoi(this.eoiId, { rejectReason: result.remark }).toPromise().then(res => {
                    this.ngOnInit()
                })
            }
        })
    }

    openReceiptFile(fileName) {
        window.open(this.SERVER_URL + 'files/' + this.eoiDetail.eoiNo + '/receipt/' + fileName)
    }

    openEoiFile(fileName) {
        window.open(this.SERVER_URL + 'files/' + this.eoiDetail.eoiNo + '/form/' + fileName)
    }
}
